import React from "react";
import Filter from "../Shop/Filter";
import "./SideBar.css";
import { Instagram, Facebook, Linkedin, Youtube } from "lucide-react";

export default function SideBar({ onFilterChange, defaultCategory }) {
  return (
    <div className="sidebar">
      <div className="sidebar__filter">
        <Filter onFilterChange={onFilterChange} defaultCategory={defaultCategory} />
      </div>
      <div className="sidebar__socials">
        <h4 className="sidebar__socials-title">Connect with TrendBay</h4>
        <div className="sidebar__social-links">
          <a href="https://www.instagram.com/trendbayds" target="_blank" className="sidebar__social-btn sidebar__social-btn--ig" rel="noreferrer">
            <Instagram size={18} />
            <span>Follow on Instagram</span>
          </a>
          <a href="https://www.facebook.com/trendbayds" target="_blank" className="sidebar__social-btn sidebar__social-btn--fb" rel="noreferrer">
            <Facebook size={18} />
            <span>Like on Facebook</span>
          </a>
          <a href="https://linkedin.com/company/trendbayds" target="_blank" className="sidebar__social-btn sidebar__social-btn--li" rel="noreferrer">
            <Linkedin size={18} />
            <span>Follow on LinkedIn</span>
          </a>
          <a href="https://www.youtube.com/@TrendBayDS" target="_blank" className="sidebar__social-btn sidebar__social-btn--yt" rel="noreferrer">
            <Youtube size={18} />
            <span>Subscribe on YouTube</span>
          </a>
        </div>
      </div>
    </div>
  );
}
